<template>
  <div class="tiny-slide text-center">
    <div class="customer-testi">
      <div class="content relative rounded shadow dark:shadow-gray-800 m-2 p-6 bg-white dark:bg-slate-900">
        <span class="material-icons text-bsd-700 text-4xl rotate-180">format_quote</span>
        <p class="text-slate-400">" {{ Testimony.content }} "</p>
        <ul class="list-none mb-0 text-amber-400 mt-3">
          <li :key="stars" v-for="stars in Testimony.stars" class="inline"><i class="uil uil-star"></i></li>
        </ul>
      </div>

      <div class="text-center mt-5">
        <img :src="Testimony.image" class="h-14 w-14 rounded-full shadow-md mx-auto" :alt="Testimony.name">
        <h6 class="mt-2 font-semibold"> {{ Testimony.name }}</h6>
        <span class="text-slate-400 text-sm">{{ Testimony.title }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import 'material-icons/iconfont/material-icons.css'
export default {
  data() {
    return {
      Testimony: {
        content: 'It seems that only fragments of the original text remain in the Lorem Ipsum texts used today.',
        stars: 4,
        name: 'Calvin Carlo',
        title: 'Manager',
        image: require('@/assets/images/client/01.jpg'),
      },
    }
  }

}
</script>

<style></style>